import { Typography } from "@mui/material";
import { Children, useState } from "react";

interface PropsTypes {
  matchTypeName?: string;
  matchDescription?: string;
  status?: string;
  date?: any;
  classname?: string;
  textColor?: string;
  variant?: string;
  fontWeight?: string;
  players?: any;
  pno?: string;
  style?:any;

}

const CardText = (props: PropsTypes) => {
  let boldiness = props.fontWeight;

  return (
    <>
      <Typography
        className={props.classname}
        variant="body2"
        color={props.textColor}
        sx={{
          fontSize: {
            lg: 12,
            md: 12,
            sm: 11,
            xs: 11,
          },
          fontWeight: boldiness,
        }}
        style={props.style}
      >
        {props.matchTypeName}
        {props.matchDescription}

        {props.date}
        {/* {props.date.split("/")[0]}/{props.date.split("/")[1]} */}

        {props.pno}
        {props.players}
       
      </Typography>
    </>
  );
};
export default CardText;
